// Copyright (c) StrangeBee 2023

export const convertBooleanToLabel = (
    initObj: Record<string, any>,
    trueLabel: string,
    falseLabel: string,
): Record<string, any> => {
    return {
        [trueLabel]: initObj.true,
        [falseLabel]: initObj.false,
    };
};

export const convertLabelToStringBoolean = (value: string, trueLabel: string): string => {
    return (value === trueLabel).toString();
};

export const formatFileSize = (bytes: number, decimals = 2): string => {
    if (bytes === 0) {
        return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
